import { useWhatsApp } from './hooks/useWhatsApp';
import { useScrollReveal } from './hooks/useScrollReveal';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ProblemSection from './components/ProblemSection';
import WhoWeServe from './components/WhoWeServe';
import ConversionSection from './components/ConversionSection';
import WhatsAppModal from './components/WhatsAppModal';
import WhyKaya from './components/WhyKaya';
import FoodShowcase from './components/FoodShowcase';
import OperationSection from './components/OperationSection';
import HighCTA from './components/HighCTA';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';

export default function Home() {
  const { isOpen, openModal, closeModal, data, updateData, generateLink } =
    useWhatsApp();
  useScrollReveal();

  return (
    <div className="min-h-screen pb-16 md:pb-0">
      <Header onOpenWhatsApp={openModal} />
      <HeroSection onOpenWhatsApp={openModal} />
      <TrustBar />
      <ProblemSection onOpenWhatsApp={openModal} />
      <WhoWeServe onOpenWhatsApp={openModal} />
      <ConversionSection
        onOpenWhatsApp={(personCount) => openModal(undefined, personCount)}
      />
      <WhyKaya />
      <FoodShowcase />
      <OperationSection onOpenWhatsApp={openModal} />
      <HighCTA onOpenWhatsApp={openModal} />
      <FAQ onOpenWhatsApp={openModal} />
      <FinalCTA onOpenWhatsApp={openModal} />
      <Footer />
      <FloatingWhatsApp onOpenWhatsApp={openModal} />
      <WhatsAppModal
        isOpen={isOpen}
        onClose={closeModal}
        data={data}
        updateData={updateData}
        generateLink={generateLink}
      />
    </div>
  );
}